import { getAnalytics, isSupported } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";

const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId,
});

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

/** GA4. Firebase 웹 앱의 Analytics 가 **곧** GA4 웹 스트림이다 — `gtag.js` 스니펫을
 *  `index.html` 에 따로 넣지 말 것. 넣으면 같은 방문이 두 번 잡힌다.
 *
 *  `measurementId` 가 비면 null 이고 `track()` 은 조용히 아무것도 안 한다. 키가
 *  빠졌다고 로그인이 죽으면 안 된다 — OpenAI 키가 비어도 직접 입력 경로는 사는
 *  것과 같은 원칙이다. 그래서 CI 의 Firebase 필수값 검사에도 넣지 않는다.
 *
 *  `isSupported()` 는 쿠키·indexedDB 가 막힌 환경(사파리 프라이빗, 일부 인앱
 *  브라우저)을 걸러낸다. 여기서 던지면 앱 첫 렌더가 통째로 죽으므로 삼킨다. */
export const analytics = measurementId
  ? isSupported()
      .then((ok) => (ok ? getAnalytics(app) : null))
      .catch(() => null)
  : Promise.resolve(null);
